import React from 'react';

import {Box, Text, Heading, OrderedList, ListItem} from '@tempo/core';
import ContentLayout from '@deezer/next/shared/layouts/ContentLayout';
import {getServerSideTranslationsWrapper} from '@deezer/next/shared/utils/next';
import {typographyOverrides} from '@deezer/next/shared/utils/typographyOverrides';

const TermsConditions = () => {
	//fixme translate https://docs.google.com/spreadsheets/d/1pTDLBJbHbLKYzP0YRFOZ0JnLOxaUX29Qtm0WqTVdN40/edit#gid=1621369957&range=12:12
	return (
		<Box p={4} textAlign={'left'}>
			<Heading as={'h1'} sx={typographyOverrides['display.s']} mt={'12px'}>
				Terms of Use for the application « Deezer for Creators »
			</Heading>

			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 1 – General remarks
			</Heading>
			<Text m={'10px'}>
				The application « Deezer for Creators » is created, developed and
				operated by DEEZER, a French corporation, registered under number RCS
				511 716 573, with its principal offices located at 12 rue d’Athènes,
				75009 PARIS, FRANCE (« DEEZER »).
			</Text>
			<Text m={'10px'}>
				These Terms of Use (hereinafter « ToU ») govern the access and use of
				the application developed by DEEZER named « Deezer for Creators » («
				Deezer for Creators App »).
			</Text>
			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 2 – The Deezer for Creators App description
			</Heading>
			<Text m={'10px'}>
				The Deezer for Creators App was developed by DEEZER to provide its
				releases providers with data and analytics enabling them to measure
				performance and analyse their audience.
			</Text>
			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 3 – Access to the Deezer for Creators App
			</Heading>
			<Text m={'10px'}>
				Access and use of the Deezer for Creators App is strictly limited to
				DEEZER’s releases providers or producers and their authorized personnel
				(“App Users”).
			</Text>
			<Text m={'10px'}>
				In order to access and use the Deezer for Creators App, every App User
				must abide by the present ToU and must:
			</Text>
			<OrderedList m={'10px'}>
				<ListItem ml={'20px'}>
					Create an account on the Deezer for Creators App;
				</ListItem>
				<ListItem ml={'20px'}>Claim a RSS feed; and</ListItem>
				<ListItem ml={'20px'}>
					Enter the verification code sent to the email address in the RSS feed;
				</ListItem>
			</OrderedList>
			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 4 – Use of the Deezer for Creators App
			</Heading>
			<Text m={'10px'}>
				The use of the Deezer for Creators App is strictly limited to DEEZER’s
				releases providers and their authorized personnel. The App User shall
				keep confidential and not communicate, transmit, reproduce, copy,
				publish, broadcast or otherwise disclose any information or data made
				available or accessible via the Deezer for Creators App.
			</Text>

			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 5 - Availability and modification of the Deezer for Creators App
			</Heading>

			<Text m={'10px'}>
				The Deezer for Creators App can be accessed 24 hours a day and seven
				days a week within the limits set out in these ToU.
			</Text>
			<Text m={'10px'}>
				DEEZER has the right to make any modifications to the Analytics by
				Deezer App as it deems necessary. Furthermore, DEEZER has the right,
				without prior notice or compensation, to temporarily remove access to
				the Deezer for Creators App in order to ensure the maintenance or
				continuity of the Deezer for Creators App or otherwise. DEEZER also has
				the right, without compensation, to shut down access permanently to the
				Deezer for Creators App.
			</Text>

			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 6 – Disclaimer of warranties
			</Heading>
			<Text m={'10px'}>
				EXCEPT AS OTHERWISE PROVIDED IN THESE TOU, TO THE MAXIMUM EXTENT
				PERMITTED BY APPLICABLE LAW, THE DEEZER FOR CREATORS APP IS PROVIDED “AS
				IS”,“AS AVAILABLE” AND WITHOUT ANY WARRANTY OF ANY KIND, EXPRESS OR
				IMPLIED, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE,
				NON INFRINGEMENT, MERCHANTABILITY, QUALITY, AND FITNESS FOR A PARTICULAR
				PURPOSE, AND ANY WARRANTIES IMPLIED BY ANY COURSE OF PERFORMANCE OR
				USAGE OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED. DEEZER DOES NOT
				WARRANT THAT (I) THE DEEZER FOR CREATORS APP WILL BE SECURE OR AVAILABLE
				AT ANY PARTICULAR TIME OR LOCATION, (II) ANY DEFECTS OR ERRORS WILL BE
				CORRECTED, (III) ANY CONTENT OR SOFTWARE AVAILABLE ON OR THROUGH THE
				DEEZER FOR CREATORS APP IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS,
				(IV) THE CONTENT ON THE DEEZER FOR CREATORS APP IS ACCURATE, ERROR-FREE,
				APPROPRIATE, COMPLIANT, OR COMPLETE, OR (V) THE RESULTS OF USING THE
				DEEZER FOR CREATORS APP WILL MEET THE APP USER’S REQUIREMENTS.
			</Text>
			<Text m={'10px'}>
				DEEZER disclaims liability for any dysfunction on the Analytics by
				Deezer App, whether it concerns its access, consultation speed, the
				temporary or definitive inaccessibility of the Deezer for Creators App,
				and the fraudulent use by third parties of the information provided on
				the Deezer for Creators App which DEEZER cannot be held responsible for.
			</Text>
			<Text m={'10px'}>
				Therefore, it is the App User’s duty to protect his/her equipment,
				notably against any form of intrusion and/or virus contamination and for
				which DEEZER can never be held liable. DEEZER can never be held liable
				for any dysfunction or damage caused to the App User’s equipment which
				are not attributable to culpable actions of DEEZER.
			</Text>
			<Text m={'10px'}>
				Furthermore, DEEZER disclaims any liability if a breach of any of its
				obligations results from acts of nature, forces, or causes beyond its
				reasonable control, including, without limitation, Internet failures,
				computer equipment failures, telecommunication equipment failures, other
				equipment failures, electrical power failures, strikes, labor disputes,
				riots, insurrections, civil disturbances, shortages of labor or
				materials, fires, floods, storms, explosions, acts of God, war,
				governmental actions, orders of domestic or foreign courts or tribunals,
				non-performance of third parties, or loss of or fluctuations in heat,
				light, or air conditioning and more broadly any unstoppable and
				unforeseen event which prevent the good execution of the orders.
			</Text>
			<Text m={'10px'}>
				DEEZER disclaims liability in the event the Deezer for Creators App is
				incompatible with certain equipment and/or functionalities of the
				equipment of the App User.
			</Text>
			<Text m={'10px'}>
				Finally, the App User is liable for his/her use of the Analytics by
				Deezer App and cannot hold DEEZER liable for any claim and/or procedure
				made against him/her in that respect. The App User shall take on every
				claim, complaint or objection and any proceedings filed against DEEZER
				by a third-party in relation to the App User’s culpable violation of
				their obligations in the course of their use of the Deezer for Creators
				App.
			</Text>
			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 7 – Intellectual property
			</Heading>
			<Text m={'10px'}>
				The general structure of the Deezer for Creators App and all elements
				composing it (such as but not limited to the logos, photos, images,
				texts, or any visuals) are the exclusive property of DEEZER and/or its
				licensors.
			</Text>
			<Text m={'10px'}>
				These elements are protected by intellectual property laws and others,
				and notably copyright law. The App User can only use these elements for
				the purpose of using the Deezer for Creators App in compliance with
				these ToU.
			</Text>
			<Text m={'10px'}>
				Any total or partial representation of the Deezer for Creators App
				and/or the elements composing them (as described above) by any means
				without the express consent of DEEZER is therefore forbidden and would
				be considered as infringement of law.
			</Text>
			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 8 – Nullity of an article
			</Heading>
			<Text m={'10px'}>
				In case one of the provisions of these ToU would be declared void or
				voidable for any reason, the remainder of the ToU will continue to apply
				in full force and effect.
			</Text>
			<Heading as={'h2'} variant="title.screen.mobile" mt={'14px'}>
				Article 9 – Applicable law and jurisdiction
			</Heading>
			<Text m={'10px'}>
				The present ToU are governed by the laws of France. In case of claims,
				the parties will try to reach an amicable agreement before any judicial
				proceeding. If no amicable agreement can be reached, any claim regarding
				the validity, the interpretation and/or the execution of the ToU shall
				be brought before the courts of the Paris, France.
			</Text>
		</Box>
	);
};

TermsConditions.getLayout = (page: React.ReactElement) => {
	return <ContentLayout>{page}</ContentLayout>;
};

export const getStaticProps = getServerSideTranslationsWrapper(() => {
	return {
		props: {
			logged: false,
			mode: 'light',
		},
	};
});

export default TermsConditions;
